import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as studentActions from '@app/actions/students'
import Restart from '@app/components/students/Start/Restart'

const mapStateToProps = (state) => {
  const { students: { participate } } = state;
  return { participate }
}

const mapDispatchToProps = (dispatch) => {
  const boundStudentActions = bindActionCreators(studentActions, dispatch)
  return { boundStudentActions }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Restart)
